import { render, staticRenderFns } from "./purchaseCheckTask.vue?vue&type=template&id=4de970e8&scoped=true"
import script from "./purchaseCheckTask.vue?vue&type=script&lang=js"
export * from "./purchaseCheckTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseCheckTask.vue?vue&type=style&index=0&id=4de970e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de970e8",
  null
  
)

export default component.exports